import env from '@beam-australia/react-env';
import { di } from '../modules';

function getApiUrl() {
    return env('API_URL') || di.container.API_URL;
}

export default getApiUrl;
